import './start.scss';
import startVideoFile from '../../assets/videos/GameMix.mp4';

class StartControls {
  constructor(lang, theme) {
    this.lang = lang;
    this.theme = theme;
  }

  buildStartSection(lang, theme) {
    let startSection = document.createElement('section');
    let startContainer = document.createElement('div');
    let startVideo = document.createElement('video');
    let startPreheader = document.createElement('h2');
    let startHeader = document.createElement('h1');
    let startButton = document.createElement('button');
    let mainSection = document.querySelector('.main-section');

    startSection.classList.add('start');
    startContainer.classList.add('start__container');
    startVideo.classList.add('start__video');
    startPreheader.classList.add('start__preheader');
    startHeader.classList.add('start__header');
    startButton.classList.add('start__button');

    if (theme === 'dark') {
      startSection.classList.add('start_theme-color_dark');
      startContainer.classList.add('start__container_theme-color_dark');
      startPreheader.classList.add('start__preheader_theme-color_dark');
      startHeader.classList.add('start__header_theme-color_dark');
      startButton.classList.add('start__button_theme-color_dark');
    } else {
      startSection.classList.add('start_theme-color_light');
      startContainer.classList.add('start__container_theme-color_light');
      startPreheader.classList.add('start__preheader_theme-color_light');
      startHeader.classList.add('start__header_theme-color_light');
      startButton.classList.add('start__button_theme-color_light');
    }

    if (lang === 'ru') {
      startPreheader.classList.add('start__preheader_lang_ru');
      startHeader.classList.add('start__header_lang_ru');
      startButton.classList.add('start__button_lang_ru');
    } else {
      startPreheader.classList.add('start__preheader_lang_en');
      startHeader.classList.add('start__header_lang_en');
      startButton.classList.add('start__button_lang_en');
    }

    startVideo.setAttribute('src', startVideoFile);
    startVideo.setAttribute('controls', 'controls');
    startVideo.setAttribute('onloadstart', 'this.volume=0.1');
    startVideo.setAttribute('autoplay', 'autoplay');
    startVideo.setAttribute('muted', 'muted');
    startVideo.setAttribute('loop', 'loop');
    startVideo.muted = 'true';
    startVideo.loop = 'true';

    startSection.appendChild(startContainer);
    startSection.appendChild(startPreheader);
    startSection.appendChild(startHeader);
    startSection.appendChild(startButton);
    startContainer.appendChild(startVideo);

    mainSection.appendChild(startSection);
  }
}

export { StartControls };